/* ═══════════════════════════════════════════════════════════════════════════
   js/jk-rooms-lead.js — кнопки заявки на странице комнатности ЖК.

   ⛔ ПОЧЕМУ ОТДЕЛЬНЫЙ ФАЙЛ (проверка 25.09.2026, P1-1). На странице комнатности
   стоят те же кнопки, что на карточке ЖК: «Оставить заявку на подбор», «В избранное»,
   «Поделиться» в колонке менеджера, «Оставить заявку» (#jkCta) и кнопка в подвале.
   Их обработчики живут в js/jk.js, а jk.js первой строкой выходит, если на странице
   нет героя карточки (#jkHero). У комнатности героя нет — и все эти кнопки молчали:
   клик не открывал ничего. Весь jk.js на комнатность не тянем (он строит героя,
   галерею и десятки блоков, которых здесь нет) — оживляем только кнопки.

   ⛔ ОКНО — ШТАТНОЕ, ТО ЖЕ, ЧТО НА КАРТОЧКЕ ЖК на телефоне: window.openCallbackModal
   (js/shared.js). Заявка уходит его же путём: /send.php, _csrf, _hp, согласие 152-ФЗ.
   Своей формы нет.

   ⛔ МЕТКА ЗАЯВКИ — «Страница комнатности — …», а не «Заказать звонок»: владелец
   должен видеть, откуда пришла заявка. Метку кладём на форму окна
   (data-lead-source, её читает js/shared.js) при открытии нашей кнопкой; при
   закрытии окна возвращаем метку страницы — чтобы «Заказать звонок» в шапке этой
   же страницы не унёс подпись кнопки колонки.

   Карточку ЖК файл не трогает: там есть #jkHero, и кнопки ведёт jk.js (выход ниже).
   ═══════════════════════════════════════════════════════════════════════════ */
(() => {
  'use strict';
  if (document.getElementById('jkHero')) return; // карточка ЖК: кнопки ведёт jk.js
  const page = typeof window.BRONI_LEAD_PAGE === 'string' ? window.BRONI_LEAD_PAGE.trim() : '';
  if (page === '') return; // не страница комнатности

  const form = document.getElementById('callbackForm');
  const modal = document.getElementById('callbackModal');
  const pageSource = page + ' — Заказать звонок';
  const setSource = (text) => { if (form) form.setAttribute('data-lead-source', text); };
  setSource(pageSource);

  // Окно закрылось (крестик, фон, Escape, отправка) — подпись кнопки снимаем.
  if (modal && form && typeof MutationObserver === 'function') {
    new MutationObserver(() => {
      if (!modal.classList.contains('active')) setSource(pageSource);
    }).observe(modal, { attributes: true, attributeFilter: ['class'] });
  }

  function openLead(label) {
    setSource(page + ' — ' + label);
    if (typeof window.openCallbackModal === 'function') { window.openCallbackModal(); return; }
    // shared.js не загрузился — заявка всё равно не должна теряться молча.
    if (modal) { modal.classList.add('active'); document.body.style.overflow = 'hidden'; }
  }

  // Кнопка → подпись в метке заявки. Подписи — те же, что у карточки
  // (CARD_LEAD_SOURCES в js/jk-card.js), чтобы отчёт сравнивал одно с одним.
  const LEAD_BUTTONS = {
    jkCta: 'кнопка «Оставить заявку»',
    jkRailCta: 'боковая колонка',
    jkCtaFooterCallback: 'блок призыва внизу',
  };
  Object.keys(LEAD_BUTTONS).forEach((id) => {
    const button = document.getElementById(id);
    if (button) button.addEventListener('click', () => openLead(LEAD_BUTTONS[id]));
  });

  // «В избранное» и «Поделиться» колонки — как на карточке (js/jk.js, bindHeroButtons).
  const fav = document.getElementById('jkRailFav');
  if (fav) fav.addEventListener('click', () => fav.classList.toggle('is-active'));
  const mainFav = document.getElementById('jkFav');
  if (mainFav) mainFav.addEventListener('click', () => mainFav.classList.toggle('active'));
  const share = document.getElementById('jkRailShare');
  if (share) share.addEventListener('click', () => {
    if (navigator.share) {
      navigator.share({ title: document.title, url: location.href }).catch(() => {});
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(location.href).catch(() => {});
      share.classList.add('is-active');
    }
  });
})();
